<template>
  <div class="main">
    <div>
      <a-form-model style="border-bottom: 1px solid #dbd7d7;margin-bottom: 20px;" :model="form" :label-col="labelCol"
        :wrapper-col="wrapperCol">
        <a-row>
          <a-col :span="4">
            <a-form-model-item :label="$t('query1')">
              {{ formShow.custno }}
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query2')">
              {{ formShow.mblno }}
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query3')">
              <div :title="formShow.cntrtotal"
                style="overflow: hidden; text-overflow: ellipsis;white-space: nowrap;width: 134px;"> {{ formShow.cntrtotal
                }}</div>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query4')">
              {{ formShow.cbm }}
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query5')">
              {{ formShow.kgs }}
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query6')">
              {{ formShow.pkgs }}
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4">
            <a-form-model-item :label="$t('query8')">
              {{ formShow.customername }}
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query9')">
              {{ formShow.portdischarge }}
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query10')">
              {{ formShow.vessel }}
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query11')">
              {{ formShow.voyno }}
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query12')">
              {{ formShow.sale }}
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query13')">
              {{ formShow.etd ? formShow.etd.substring(0, 10) : '' }}
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="4">
            <a-form-model-item :label="$t('query14')">
              {{ formShow.blfrt }}
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query7')">
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query15')">
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query16')">
              {{ formShow.destination }}
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item :label="$t('query17')">
              {{ formShow.portload }}
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item :label-col="{ span: 1 }" :wrapper-col="{ span: 23 }" :label="$t('query18')">

            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <a-spin :spinning="loading">

        <div class="opera">
          <span style="font-weight: bold;margin-right: 20px;">应收</span>
          <div class="btn" @click="handleAdd">添加</div>
          <div class="btn" @click="handleCopy">复制</div>
          <div class="btn" @click="handleSave">保存</div>
          <div class="btn blue" @click="handleInto">模板引入</div>
          <div class="btn red" @click="handleDelete">删除</div>
          <div class="btn blue" @click="handleClear">清空缓存并刷新</div>
          <div :style="{ color: (tips ? 'green' : 'red') }">{{ tips ? '' : '有数据未保存' }}</div>
        </div>
        <ve-table @keydown.enter.native="handleMoveA" @keydown.down.native="handleDownA" class="tableRef"
          :max-height="300" :checkbox-option="checkboxOption" rowKeyFieldName="rowKey" ref="tableRef" :scroll-width="0"
          :border-x="true" :fixed-header="true" :columns="columns" :table-data="tableData"
          :cellSelectionOption="cellSelectionOption" :editOption="editOption" :cell-style-option="cellStyleOption"
          :rowStyleOption="rowStyleOption" border-y />
        <div class="opera">
          <span style="font-weight: bold;margin-right: 20px;">应付</span>
          <div class="btn" @click="handleAddB">添加</div>
          <div class="btn" @click="handleCopyB">复制</div>
          <div class="btn" @click="handleSave">保存</div>
          <div class="btn blue" @click="handleIntoB">模板引入</div>
          <div class="btn red" @click="handleDeleteB">删除</div>
          <div :style="{ color: (tipsB ? 'green' : 'red') }">{{ tipsB ? '' : '有数据未保存' }}</div>
        </div>
        <ve-table @keydown.enter.native="handleMoveB" @keydown.down.native="handleDownB" class="tableRefB"
          :max-height="300" :checkbox-option="checkboxOptionB" rowKeyFieldName="rowKey" ref="tableRefB" :scroll-width="0"
          :border-x="true" :fixed-header="true" :columns="columnsB" :table-data="tableDataB"
          :cellSelectionOption="cellSelectionOptionB" :editOption="editOption" :cell-style-option="cellStyleOption"
          :rowStyleOption="rowStyleOption" border-y />
      </a-spin>
      <a-modal title="模板引入" @ok="handleSave" width="1200px" @cancel="tempFlag = false" :visible="tempFlag">
        <a-table :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
          type: 'radio',
        }" rowKey="id" :loading="tempLoad" size="small" :pagination="false" :columns="columnsTemp"
          :data-source="tempList" bordered></a-table>
        <template slot="footer">
          <a-spin :spinning="intoLoad">
            <div style="width: 100px;margin-left: 90%;" class="btn" @click="sureInto">引入</div>
          </a-spin>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import { mapGetters } from 'vuex'
export default {
  name: 'index',
  data() {
    return {
      labelCol: { span: 8 },
      selectedRowKeys: [],
      addDownIndexB: 0,
      addDownIndex: 0,
      intoLoad: false,
      columnsTemp: [
        {
          title: '模板名称',
          dataIndex: 'name',
        },
        {
          title: '模板说明',
          dataIndex: 'description',
        },
        {
          title: '备注',
          dataIndex: 'remark',
        },
      ],
      tempList: [],
      wrapperCol: { span: 16 },
      baseLink: 'http://60.209.125.238:35100/',
      form: {},
      rowStyleOption: {
        clickHighlight: false,
        hoverHighlight: false,
      },
      checkboxOption: {
        selectedRowKeys: [],
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.checkboxOption.selectedRowKeys = selectedRowKeys
        },
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.checkboxOption.selectedRowKeys = selectedRowKeys
        },
      },
      checkboxOptionB: {
        selectedRowKeys: [],
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.checkboxOptionB.selectedRowKeys = selectedRowKeys
        },
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.checkboxOptionB.selectedRowKeys = selectedRowKeys
        },
      },
      editOption: {
        beforeStartCellEditing: ({ row, column, cellValue }) => {

        },
        beforeCellValueChange: ({ row, column, changeValue }) => {

        },
        afterCellValueChange: ({ row, column, changeValue }) => {
          if (column.key === 'amount') {
            changeValue = changeValue.toString()
            row['amount'] = changeValue.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
            row['taxUnitPrice'] = (row['amount'] / row['quantity']).toFixed(4)
            row['unitPrice'] = (row['taxUnitPrice'] / (1 + (row['taxRate'] / 100))).toFixed(4)
            row['noTaxAmount'] = (row['unitPrice'] * row['quantity']).toFixed(2)
          }
          if (column.key === 'noTaxAmount') {
            changeValue = changeValue.toString()
            row['noTaxAmount'] = changeValue.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
            row['unitPrice'] = (row['noTaxAmount'] / row['quantity']).toFixed(4)
            row['taxUnitPrice'] = ((1 + (row['taxRate'] / 100)) * row['unitPrice']).toFixed(4)
            row['amount'] = (row['taxUnitPrice'] * row['quantity']).toFixed(2)
          }
          if (column.key === 'taxRate') {
            changeValue = changeValue.toString()
            row['unitPrice'] = (row['taxUnitPrice'] / (1 + (row['taxRate'] / 100))).toFixed(4)
             row['noTaxAmount'] = (row['unitPrice'] * row['quantity']).toFixed(2)
          }
          if (column.key === 'exchangeRate') {
            changeValue = changeValue.toString()
            row['exchangeRate'] = changeValue.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
          }
          if (column.key === 'unitPrice') {
            changeValue = changeValue.toString()
            row['unitPrice'] = changeValue.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
            row['taxUnitPrice'] = ((1 + (row['taxRate'] / 100)) * row['unitPrice']).toFixed(4)
            row['amount'] = (row['taxUnitPrice'] * row['quantity']).toFixed(2)
            row['noTaxAmount'] = (row['unitPrice'] * row['quantity']).toFixed(2)
          }
          if (column.key === 'quantity') {
            changeValue = changeValue.toString()
            row['quantity'] = changeValue.replace(/[^0-9]/g, '')
            row['amount'] = (row['taxUnitPrice'] * row['quantity']).toFixed(2)
            row['noTaxAmount'] = (row['unitPrice'] * row['quantity']).toFixed(2)
          }
          if (column.key === 'taxUnitPrice') {
            changeValue = changeValue.toString()
            row['taxUnitPrice'] = changeValue.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3')
            row['unitPrice'] = (row['taxUnitPrice'] / (1 + (row['taxRate'] / 100))).toFixed(4)
            row['noTaxAmount'] = (row['unitPrice'] * row['quantity']).toFixed(2)
            row['amount'] = (row['taxUnitPrice'] * row['quantity']).toFixed(2)
          }
        }
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          return "table-body-cell-class1";
        },
      },
      cellSelectionOption: {
        enable: true
      },
      cellSelectionOptionB: {
        enable: true
      },
      formShow: {},
      kindpkgsViewIndex: null,
      kindpkgsViewIndexB: null,
      ctnallViewIndex: null,
      ctnallList: [
        {
          name: '箱子1'
        },
        {
          name: '箱子2'
        },
        {
          name: '箱子3'
        },
        {
          name: '箱子4'
        },
      ],
      columns: [
        {
          field: "",
          key: "b",
          type: "checkbox",
          title: "",
          width: 20,
          align: "center",
          fixed: "left",
          edit: false,
        },
        {
          field: "",
          key: "a",
          title: "",
          width: 30,
          align: "center",
          operationColumn: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "feeStatus",
          key: "feeStatus",
          title: this.$t('table1'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "feeName",
          key: "feeName",
          title: this.$t('table2'),
          align: "center",
          width: "150px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-select
                size="small"
                value={row['feeName']}
                showSearch
                ref="feeName"
                class="feeName"
                allow-clear={true}
                style="width: 100%"
                filter-option={this.filterOption}
                on-change={(val) => {
                  if (val !== undefined) {
                    const data = this.codeList[val]
                    row['feeName'] = data.name
                    row['feeCode'] = data.code
                    row['unit'] = data.defaultUnit
                    row['currency'] = data.defaultCurr
                    row['taxRate'] = data.taxRate
                    row['customerType'] = data.defaultDebit
                    this.customerTypeList.forEach(item => {
                      if (data.defaultDebit == item.name) {
                        this.handleChange(item.code, row)
                      }
                    })
                    row['feeDescription'] = data.description
                    this.$forceUpdate()
                  } else {
                    row['feeName'] = ''
                  }
                }}
                on-focus={(val) => {
                  this.ctnallViewIndex = rowIndex
                  this.cellSelectionOption.enable = false
                }}
                on-blur={(val) => {
                  this.cellSelectionOption.enable = true
                  this.ctnallViewIndex = null
                  this.$refs['tableRef'].setCellSelection({ rowKey: rowIndex + 1, colKey: 'feeName' });
                }}
                on-select={(val) => {
                  this.cellSelectionOption.enable = true
                }}
              >
                {this.codeList.map((item, index) => {
                  return <a-select-option value={index}>{item.name}</a-select-option>
                })}
              </a-select>
            )
          }
        },
        {
          field: "feeDescription",
          key: "feeDescription",
          title: this.$t('table3'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-select
                size="small"
                value={row['feeDescription']}
                showSearch
                ref="feeDescription"
                class="feeDescription"
                allow-clear={true}
                style="width: 100%"
                filter-option={this.filterOption}
                on-change={(val) => {
                  if (val !== undefined) {
                    const data = this.codeList[val]
                    row['feeName'] = data.name
                    row['feeDescription'] = data.description
                    this.$forceUpdate()
                  } else {
                    row['feeDescription'] = ''
                  }
                }}
                on-focus={(val) => {
                  this.ctnallViewIndex = rowIndex
                  this.cellSelectionOption.enable = false
                }}
                on-blur={(val) => {
                  this.cellSelectionOption.enable = true
                  this.ctnallViewIndex = null
                  this.$refs['tableRef'].setCellSelection({ rowKey: rowIndex + 1, colKey: 'feeDescription' });
                }}
                on-select={(val) => {
                  this.cellSelectionOption.enable = true
                }}
              >
                {this.codeList.map((item, index) => {
                  return <a-select-option value={index}>{item.description}</a-select-option>
                })}
              </a-select>
            )
          }
        },
        {
          field: "customerType",
          key: "customerType",
          title: this.$t('table4'),
          align: "center",
          width: "130px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-select
                size="small"
                value={row['customerType']}
                showSearch
                ref="customerType"
                class="customerType"
                allow-clear={true}
                style="width: 100%"
                filter-option={this.filterOption}
                on-change={(val) => {
                  if (val !== undefined) {
                    const data = this.customerTypeList[val]
                    row['customerType'] = data.name
                    row['customerName'] = ''
                    row['customerCode'] = ''
                    this.handleChange(data.code, row)
                    this.$forceUpdate()
                  } else {
                    row['customerType'] = ''
                  }
                }}
                on-focus={(val) => {
                  this.ctnallViewIndex = rowIndex
                  this.cellSelectionOption.enable = false
                }}
                on-blur={(val) => {
                  this.cellSelectionOption.enable = true
                  this.ctnallViewIndex = null
                  this.$refs['tableRef'].setCellSelection({ rowKey: rowIndex + 1, colKey: 'customerType' });
                }}
                on-select={(val) => {
                  this.cellSelectionOption.enable = true
                }}
              >
                {this.customerTypeList.map((item, index) => {
                  return <a-select-option value={index}>{item.name}</a-select-option>
                })}
              </a-select>
            )
          }
        },
        {
          field: "customerName",
          key: "customerName",
          title: this.$t('table5'),
          align: "center",
          width: "130px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-select
                size="small"
                value={row['customerName']}
                showSearch
                ref="customerName"
                class="customerName"
                allow-clear={true}
                style="width: 100%"
                filter-option={this.filterOption}
                on-change={(val) => {
                  if (val !== undefined) {
                    const data = this.customerList[val]
                    row['customerName'] = data.name
                    row['customerCode'] = data.code
                    this.$forceUpdate()
                  } else {
                    row['customerName'] = ''
                  }
                }}
                on-focus={(val) => {
                  this.ctnallViewIndex = rowIndex
                  this.cellSelectionOption.enable = false
                }}
                on-blur={(val) => {
                  this.ctnallViewIndex = null
                  setTimeout(() => {
                    this.$refs['tableRef'].setCellSelection({ rowKey: rowIndex + 1, colKey: 'customerName' });
                  }, 100)
                  this.cellSelectionOption.enable = true
                }}
                on-select={(val) => {
                  this.cellSelectionOption.enable = true
                }}
              >
                <a-spin v-show={this.fetching} slot="notFoundContent" size="small" > </a-spin>
                {this.customerList.map((item, index) => {
                  return <a-select-option value={index}>{item.name}</a-select-option>
                })}
              </a-select>
            )
          }
        },
        {
          field: "unit",
          key: "unit",
          title: this.$t('table6'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-select
                size="small"
                value={row['unit']}
                showSearch
                ref="unit"
                class="unit"
                allow-clear={true}
                style="width: 100%"
                filter-option={this.filterOption}
                on-change={(val) => {
                  if (val !== undefined) {
                    const data = this.unitList[val]
                    row['unit'] = data.name
                    this.$forceUpdate()
                  } else {
                    row['unit'] = ''
                  }
                }}
                on-focus={(val) => {
                  this.ctnallViewIndex = rowIndex
                  this.cellSelectionOption.enable = false
                }}
                on-blur={(val) => {
                  this.ctnallViewIndex = null
                  setTimeout(() => {
                    this.$refs['tableRef'].setCellSelection({ rowKey: rowIndex + 1, colKey: 'unit' });
                  }, 100)
                  this.cellSelectionOption.enable = true
                }}
                on-select={(val) => {
                  this.cellSelectionOption.enable = true
                }}
              >
                {this.unitList.map((item, index) => {
                  return <a-select-option value={index}>{item.name}</a-select-option>
                })}
              </a-select>
            )
          }
        },
        {
          field: "unitPrice",
          key: "unitPrice",
          title: this.$t('table37'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "taxUnitPrice",
          key: "taxUnitPrice",
          title: this.$t('table7'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "quantity",
          key: "quantity",
          title: this.$t('table8'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "amount",
          key: "amount",
          title: this.$t('table9'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "noTaxAmount",
          key: "noTaxAmount",
          title: this.$t('table10'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "taxRate",
          key: "taxRate",
          title: this.$t('table11'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "exchangeRate",
          key: "exchangeRate",
          title: this.$t('table12'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "remark",
          key: "remark",
          title: this.$t('table13'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "currency",
          key: "currency",
          title: this.$t('table14'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-select
                size="small"
                value={row['currency']}
                showSearch
                ref="currency"
                class="currency"
                allow-clear={true}
                style="width: 100%"
                filter-option={this.filterOption}
                on-change={(val) => {
                  if (val !== undefined) {
                    const data = this.currencyList[val]
                    row['currency'] = data.codeName
                    this.getExchange(data.codeName, row)
                    this.$forceUpdate()
                  } else {
                    row['currency'] = ''
                  }
                }}
                on-focus={(val) => {
                  this.ctnallViewIndex = rowIndex
                  this.cellSelectionOption.enable = false
                }}
                on-blur={(val) => {
                  this.ctnallViewIndex = null
                  setTimeout(() => {
                    this.$refs['tableRef'].setCellSelection({ rowKey: rowIndex + 1, colKey: 'currency' });
                  }, 100)
                  this.cellSelectionOption.enable = true
                }}
                on-select={(val) => {
                  this.cellSelectionOption.enable = true
                }}
              >
                {this.currencyList.map((item, index) => {
                  return <a-select-option value={index}>{item.codeName}</a-select-option>
                })}
              </a-select>
            )
          }
        },
        {
          field: "number1",
          key: "number1",
          title: this.$t('table15'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "number2",
          key: "number2",
          title: this.$t('table16'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "isOpen",
          key: "isOpen",
          title: this.$t('table17'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-checkbox
                checked={row.isOpen}
                on-change={(e) => {
                  row['isOpen'] = e.target.checked
                  this.$forceUpdate()
                }}
              >
              </a-checkbox >
            )
          }
        },
        {
          field: "isAdvancedPay",
          key: "isAdvancedPay",
          title: this.$t('table18'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-checkbox
                checked={row.isAdvancedPay}
                on-change={(e) => {
                  row['isAdvancedPay'] = e.target.checked
                  this.$forceUpdate()
                }}
              >
              </a-checkbox >
            )
          }
        },
        {
          field: "isInvoice",
          key: "isInvoice",
          title: this.$t('table19'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-checkbox
                checked={row.isInvoice}
                on-change={(e) => {
                  row['isInvoice'] = e.target.checked
                  this.$forceUpdate()
                }}
              >
              </a-checkbox >
            )
          }
        },
        {
          field: "createdUserName",
          key: "createdUserName",
          title: this.$t('table20'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "createdTime",
          key: "createdTime",
          title: this.$t('table21'),
          align: "center",
          width: "150px",
          edit: false,
        },
        {
          field: "settlement",
          key: "settlement",
          title: this.$t('table22'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "invoice",
          key: "invoice",
          title: this.$t('table23'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "debitNO",
          key: "debitNO",
          title: this.$t('table24'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "updatedUserName",
          key: "updatedUserName",
          title: this.$t('table25'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "updatedTime",
          key: "updatedTime",
          title: this.$t('table26'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "orderInvSettlement",
          key: "orderInvSettlement",
          title: this.$t('table27'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "orderinvoice",
          key: "orderinvoice",
          title: this.$t('table28'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "auditOperator",
          key: "auditOperator",
          title: this.$t('table29'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "auditDate",
          key: "auditDate",
          title: this.$t('table30'),
          align: "center",
          width: "150px",
          edit: false,
        },
      ],
      columnsB: [
        {
          field: "",
          key: "b",
          type: "checkbox",
          title: "",
          width: 20,
          align: "center",
          edit: false,
        },
        {
          field: "",
          key: "a",
          title: "",
          width: 30,
          align: "center",
          operationColumn: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "feeStatus",
          key: "feeStatus",
          title: this.$t('table1'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "feeName",
          key: "feeName",
          title: this.$t('table32'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-select
                size="small"
                value={row['feeName']}
                showSearch
                ref="feeName"
                class="feeName"
                allow-clear={true}
                style="width: 100%"
                filter-option={this.filterOption}
                on-change={(val) => {
                  if (val !== undefined) {
                    const data = this.codeList[val]
                    row['feeName'] = data.name
                    row['feeCode'] = data.code
                    row['unit'] = data.defaultUnit
                    row['currency'] = data.defaultCurr
                    row['taxRate'] = data.taxRate
                    row['customerType'] = data.defaultDebit
                    this.customerTypeList.forEach(item => {
                      if (data.defaultDebit == item.name) {
                        this.handleChange(item.code, row)
                      }
                    })
                    row['feeDescription'] = data.description
                    this.$forceUpdate()
                  } else {
                    row['feeName'] = ''
                  }
                }}
                on-focus={(val) => {
                  this.ctnallViewIndex = rowIndex
                  this.cellSelectionOptionB.enable = false
                }}
                on-blur={(val) => {
                  this.cellSelectionOptionB.enable = true
                  this.ctnallViewIndex = null
                  this.$refs['tableRefB'].setCellSelection({ rowKey: rowIndex + 1, colKey: 'feeName' });
                }}
                on-select={(val) => {
                  this.cellSelectionOptionB.enable = true
                }}
              >
                {this.codeList.map((item, index) => {
                  return <a-select-option value={index}>{item.name}</a-select-option>
                })}
              </a-select>
            )
          }
        },
        {
          field: "customerType",
          key: "customerType",
          title: this.$t('table4'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-select
                size="small"
                value={row['customerType']}
                showSearch
                ref="customerType"
                class="customerType"
                allow-clear={true}
                style="width: 100%"
                filter-option={this.filterOption}
                on-change={(val) => {
                  if (val !== undefined) {
                    const data = this.customerTypeList[val]
                    row['customerType'] = data.name
                    row['customerName'] = ''
                    row['customerCode'] = ''
                    this.handleChange(data.code, row)
                    this.$forceUpdate()
                  } else {
                    row['customerType'] = ''
                  }
                }}
                on-focus={(val) => {
                  this.ctnallViewIndex = rowIndex
                  this.cellSelectionOptionB.enable = false
                }}
                on-blur={(val) => {
                  this.cellSelectionOptionB.enable = true
                  this.ctnallViewIndex = null
                  this.$refs['tableRefB'].setCellSelection({ rowKey: rowIndex + 1, colKey: 'customerType' });
                }}
                on-select={(val) => {
                  this.cellSelectionOptionB.enable = true
                }}
              >
                {this.customerTypeList.map((item, index) => {
                  return <a-select-option value={index}>{item.name}</a-select-option>
                })}
              </a-select>
            )
          }
        },
        {
          field: "customerName",
          key: "customerName",
          title: this.$t('table5'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-select
                size="small"
                value={row['customerName']}
                showSearch
                ref="customerName"
                class="customerName"
                allow-clear={true}
                style="width: 100%"
                filter-option={this.filterOption}
                on-change={(val) => {
                  if (val !== undefined) {
                    const data = this.customerList[val]
                    row['customerName'] = data.name
                    row['customerCode'] = data.code
                    this.$forceUpdate()
                  } else {
                    row['customerName'] = ''
                  }
                }}
                on-focus={(val) => {
                  this.ctnallViewIndex = rowIndex
                  this.cellSelectionOptionB.enable = false
                }}
                on-blur={(val) => {
                  this.ctnallViewIndex = null
                  setTimeout(() => {
                    this.$refs['tableRefB'].setCellSelection({ rowKey: rowIndex + 1, colKey: 'customerName' });
                  }, 100)
                  this.cellSelectionOptionB.enable = true
                }}
                on-select={(val) => {
                  this.cellSelectionOptionB.enable = true
                }}
              >
                <a-spin v-show={this.fetching} slot="notFoundContent" size="small" > </a-spin>
                {this.customerList.map((item, index) => {
                  return <a-select-option value={index}>{item.name}</a-select-option>
                })}
              </a-select>
            )
          }
        },
        {
          field: "customerName1",
          key: "customerName1",
          title: this.$t('table33'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "unit",
          key: "unit",
          title: this.$t('table6'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-select
                size="small"
                value={row['unit']}
                showSearch
                ref="unit"
                class="unit"
                allow-clear={true}
                style="width: 100%"
                filter-option={this.filterOption}
                on-change={(val) => {
                  if (val !== undefined) {
                    const data = this.unitList[val]
                    row['unit'] = data.name
                    this.$forceUpdate()
                  } else {
                    row['unit'] = ''
                  }
                }}
                on-focus={(val) => {
                  this.ctnallViewIndex = rowIndex
                  this.cellSelectionOptionB.enable = false
                }}
                on-blur={(val) => {
                  this.ctnallViewIndex = null
                  setTimeout(() => {
                    this.$refs['tableRefB'].setCellSelection({ rowKey: rowIndex + 1, colKey: 'unit' });
                  }, 100)
                  this.cellSelectionOptionB.enable = true
                }}
                on-select={(val) => {
                  this.cellSelectionOptionB.enable = true
                }}
              >
                {this.unitList.map((item, index) => {
                  return <a-select-option value={index}>{item.name}</a-select-option>
                })}
              </a-select>
            )
          }
        },
        {
          field: "unitPrice",
          key: "unitPrice",
          title: this.$t('table37'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "taxUnitPrice",
          key: "taxUnitPrice",
          title: this.$t('table7'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "quantity",
          key: "quantity",
          title: this.$t('table8'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "amount",
          key: "amount",
          title: this.$t('table9'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "currency",
          key: "currency",
          title: this.$t('table14'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-select
                size="small"
                value={row['currency']}
                showSearch
                ref="currency"
                class="currency"
                allow-clear={true}
                style="width: 100%"
                filter-option={this.filterOption}
                on-change={(val) => {
                  if (val !== undefined) {
                    const data = this.currencyList[val]
                    row['currency'] = data.codeName
                    this.getExchange(data.codeName, row)
                    this.$forceUpdate()
                  } else {
                    row['currency'] = ''
                  }
                }}
                on-focus={(val) => {
                  this.ctnallViewIndex = rowIndex
                  this.cellSelectionOptionB.enable = false
                }}
                on-blur={(val) => {
                  this.ctnallViewIndex = null
                  setTimeout(() => {
                    this.$refs['tableRefB'].setCellSelection({ rowKey: rowIndex + 1, colKey: 'currency' });
                  }, 100)
                  this.cellSelectionOptionB.enable = true
                }}
                on-select={(val) => {
                  this.cellSelectionOptionB.enable = true
                }}
              >
                {this.currencyList.map((item, index) => {
                  return <a-select-option value={index}>{item.codeName}</a-select-option>
                })}
              </a-select>
            )
          }
        },
        {
          field: "remark",
          key: "remark",
          title: this.$t('table13'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "exchangeRate",
          key: "exchangeRate",
          title: this.$t('table12'),
          align: "center",
          width: "100px",
          edit: true,
        },
        {
          field: "isAdvancedPay",
          key: "isAdvancedPay",
          title: this.$t('table18'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-checkbox
                checked={row.isAdvancedPay}
                on-change={(e) => {
                  row['isAdvancedPay'] = e.target.checked
                  this.$forceUpdate()
                }}
              >
              </a-checkbox >
            )
          }
        },
        {
          field: "isOpen",
          key: "isOpen",
          title: this.$t('table17'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-checkbox
                checked={row.isOpen}
                on-change={(e) => {
                  row['isOpen'] = e.target.checked
                  this.$forceUpdate()
                }}
              >
              </a-checkbox >
            )
          }
        },
        {
          field: "isInvoice",
          key: "isInvoice",
          title: this.$t('table19'),
          align: "center",
          width: "100px",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <a-checkbox
                checked={row.isInvoice}
                on-change={(e) => {
                  row['isInvoice'] = e.target.checked
                  this.$forceUpdate()
                }}
              >
              </a-checkbox >
            )
          }
        },
        {
          field: "createdUserName",
          key: "createdUserName",
          title: this.$t('table20'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "createdTime",
          key: "createdTime",
          title: this.$t('table21'),
          align: "center",
          width: "150px",
          edit: false,
        },
        {
          field: "settlement",
          key: "settlement",
          title: this.$t('table22'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "invoice",
          key: "invoice",
          title: this.$t('table23'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "orderamount",
          key: "orderamount",
          title: this.$t('table34'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "debitNO",
          key: "debitNO",
          title: this.$t('table24'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "updatedUserName",
          key: "updatedUserName",
          title: this.$t('table25'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "updatedTime",
          key: "updatedTime",
          title: this.$t('table26'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "orderInvSettlement",
          key: "orderInvSettlement",
          title: this.$t('table27'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "orderinvoice",
          key: "orderinvoice",
          title: this.$t('table28'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "orderinvoice1",
          key: "orderinvoice1",
          title: this.$t('table36'),
          align: "center",
          width: "100px",
          edit: false,
        },
        {
          field: "orderinvoice2",
          key: "orderinvoice2",
          title: this.$t('table35'),
          align: "center",
          width: "100px",
          edit: false,
        },
      ],
      tableData: [],
      tableDataB: [],
      reqInstance: null,
      loading: false,
      deleteList: [],
      customerTypeList: [],
      unitList: [],
      currencyList: [],
      codeList: [],
      customerList: [],
      oldList: [],
      startColKey: '',
      seleectIndex: null,
      startColKeyB: '',
      seleectIndexB: null,
      tempFlag: false,
      tempLoad: false,
      tipsB: false,
      tips: false
    }
  },
  computed: {
    ...mapGetters([
      'saveList',
    ])
  },
  created() {
    window.addEventListener('message', (messageEvent) => {
      if (messageEvent.data.token) {
        const token = JSON.parse(messageEvent.data.token).value
        localStorage.setItem('tokenDJY', token)
        this.formShow = messageEvent.data.data
        this.customerTypeList = messageEvent.data.customerTypeList
        this.$forceUpdate()
        this.getDetails()
        this.getSelectInfo()
      }
      if (messageEvent.data.type === 'close') {
        sessionStorage.removeItem('saveList')
      }
      if (messageEvent.data.type === 'empty') {
        const arr = sessionStorage.getItem('saveList') ? JSON.parse(sessionStorage.getItem('saveList')) : []
        arr.forEach((item, index) => {
          if (item.id === messageEvent.data.id) {
            arr.splice(index, 1)
          }
        })
        sessionStorage.setItem('saveList',JSON.stringify(arr))
      }
      if (messageEvent.data.type === 'save') {
        this.unloadHandler()
      }
    }, false)
    window.addEventListener('unload', e => this.unloadHandler(e))
  },
  mounted() {
    document.onkeydown = (event) => {
      if (event.key === 'Backspace') {
        let index = null
        let col = null
        let dom = ''
        if (this.$refs['tableRef'].getRangeCellSelection()) {
          const indexA = this.$refs['tableRef'].getRangeCellSelection().selectionRangeKeys.startRowKey
          const colA = this.$refs['tableRef'].getRangeCellSelection().selectionRangeKeys.startColKey
          index = indexA
          col = colA
          dom = document.getElementsByClassName('tableRef')[0].getElementsByClassName(col)[index - 1]
        }
        if (this.$refs['tableRefB'].getRangeCellSelection()) {
          const indexB = this.$refs['tableRefB'].getRangeCellSelection().selectionRangeKeys.startRowKey
          const colB = this.$refs['tableRefB'].getRangeCellSelection().selectionRangeKeys.startColKey
          index = indexB
          col = colB
          dom = document.getElementsByClassName('tableRefB')[0].getElementsByClassName(col)[index - 1]
        }
        if (dom) {
          let val = dom.getElementsByTagName('input')[0].value
          dom.getElementsByTagName('input')[0].value = val.substr(0, val.length - 1)
          var evt = document.createEvent('HTMLEvents');
          evt.initEvent('input', true, false);
          dom.getElementsByTagName('input')[0].dispatchEvent(evt);
        }
      }
      const arr = []
      if (document.getElementsByClassName('ant-select-dropdown').length > 0) {
        document.getElementsByClassName('ant-select-dropdown').forEach((item) => {
          const style = item.style
          if (style.display !== 'none') {
            arr.push(1)
          }
        })
      }
      if (event.key === 'Enter') {
        event.preventDefault();
        if (arr.length === 0) {
          this.cellSelectionOption.enable = true
          if (arr.length === 0) {
            if (this.seleectIndex) {
              this.$refs['tableRef'].setCellSelection({ rowKey: this.seleectIndex, colKey: this.startColKey });
            }
            if (this.seleectIndexB) {
              this.$refs['tableRefB'].setCellSelection({ rowKey: this.seleectIndexB, colKey: this.startColKeyB });
            }
            setTimeout(() => {
              if (document.getElementsByClassName('ve-table-cell-selection')) {
                const activeDom = document.getElementsByClassName('ve-table-cell-selection')[0].firstChild
                if (this.isDOM(activeDom)) {
                  activeDom.click()
                }
              }
            }, 100)
          }
        } else {
          if (this.seleectIndex) {
            this.cellSelectionOption.enable = false
            this.cellSelectionOptionB.enable = true
          }
          if (this.seleectIndexB) {
            this.cellSelectionOption.enable = true
            this.cellSelectionOptionB.enable = false
          }
        }
      }
      if (arr.length === 0) {
        if (this.addDownIndex === this.tableData.length) {
          if (event.key === 'ArrowDown') {
            this.handleAdd()
          }
        }
        if (this.addDownIndexB === this.tableDataB.length) {
          if (event.key === 'ArrowDown') {
            this.handleAddB()
          }
        }
      }

    }
  },
  watch: {
    tableData: {
      deep: true,
      immediate: true,
      handler(nVal, oVal) {
        const arr = []
        nVal.forEach(item => {
          if (!item.id) {
            arr.push(1)
          }
        })
        if (arr.length > 0) {
          this.tips = false
        } else {
          this.tips = true
        }
      }
    },
    tableDataB: {
      deep: true,
      immediate: true,
      handler(nVal, oVal) {
        const arr = []
        nVal.forEach(item => {
          if (!item.id) {
            arr.push(1)
          }
        })
        if (arr.length > 0) {
          this.tipsB = false
        } else {
          this.tipsB = true
        }
      }
    }
  },
  methods: {
    handleDelete() {
      this.checkboxOption.selectedRowKeys.forEach(item => {
        this.tableData.forEach((ite, index) => {
          if (ite.rowKey == item) {
            this.tableData.splice(index, 1)
            if (ite.id) {
              this.deleteList.push(ite)
            }
          }
        })
      })
      this.tableData.forEach((ite, index) => {
        ite.rowKey = index + 1
      })
      this.checkboxOption.selectedRowKeys = []
    },
    unloadHandler() {
      const list = sessionStorage.getItem('saveList') ? JSON.parse(sessionStorage.getItem('saveList')) : []
      const data = {
        id: this.formShow.id,
        tableData: this.tableData,
        tableDataB: this.tableDataB
      }
      if (list.length === 0) {
        const arr = []
        arr.push(data)
        sessionStorage.setItem('saveList', JSON.stringify(arr))
      } else {
        const saveArr = []
        const arr = JSON.parse(JSON.stringify(list))
        arr.forEach((item, index) => {
          if (item.id === data.id) {
            saveArr.push(index)
          }
        })
        if (saveArr.length === 0) {
          arr.push(data)
          sessionStorage.setItem('saveList', JSON.stringify(arr))
        } else {
          arr[saveArr[0]] = data
          sessionStorage.setItem('saveList', JSON.stringify(arr))
        }
      }
    },
    handleDeleteB() {
      this.checkboxOptionB.selectedRowKeys.forEach(item => {
        this.tableDataB.forEach((ite, index) => {
          if (ite.rowKey == item) {
            this.tableDataB.splice(index, 1)
            if (ite.id) {
              this.deleteList.push(ite)
            }
          }
        })
      })
      this.tableDataB.forEach((ite, index) => {
        ite.rowKey = index + 1
      })
      this.checkboxOptionB.selectedRowKeys = []
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    sureInto() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请先选择')
      } else {
        this.intoLoad = true
        axios.get(this.baseLink + 'FeeTemplate/Detail?id=' + this.selectedRowKeys[0], {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('tokenDJY')
          }
        }).then(res => {
          if (res.data.success) {
            const arr = res.data.data.detail
            if (this.tempType === 'A') {
              this.tableData = this.tableData.concat(arr)
              this.tableData.forEach((item, index) => {
                item.rowKey = index + 1
                item.quantity = 1
                item.noTaxAmount = (item.quantity * item.unitPrice).toFixed(2)
                item.amount = (item.quantity * item.taxUnitPrice).toFixed(2)
                item.customerType = item.custType
                delete item.id
              })
            }
            if (this.tempType === 'B') {
              this.tableDataB = this.tableDataB.concat(arr)
              this.tableDataB.forEach((item, index) => {
                item.rowKey = index + 1
                item.quantity = 1
                item.noTaxAmount = (item.quantity * item.unitPrice).toFixed(2)
                item.amount = (item.quantity * item.taxUnitPrice).toFixed(2)
                item.customerType = item.custType
                delete item.id
              })
            }
            this.$forceUpdate()
            this.tempFlag = false
          } else {
            this.$message.error(res.data.message)
          }
          this.intoLoad = false
        }).catch((error) => {
          console.log(error)
          this.intoLoad = false
        });
      }
      console.log(this.selectedRowKeys)
    },
    handleInto() {
      this.tempFlag = true
      this.tempLoad = true
      this.tempType = 'A'
      axios.post(this.baseLink + 'FeeTemplate/Page',
        {
          pageNo: 1,
          pageSize: 999,
          feeType: '应收'
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('tokenDJY')
          }
        }).then(res => {
          this.tempLoad = false
          this.tempList = res.data.data.rows
        }).catch(function (error) {
          console.log(error);
        });
    },
    handleIntoB() {
      this.tempFlag = true
      this.tempLoad = true
      this.tempType = 'B'
      axios.post(this.baseLink + 'FeeTemplate/Page',
        {
          pageNo: 1,
          pageSize: 999,
          feeType: '应付'
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('tokenDJY')
          }
        }).then(res => {
          this.tempLoad = false
          this.tempList = res.data.data.rows
        }).catch(function (error) {
          console.log(error);
        });
    },
    handleClear() {
      sessionStorage.removeItem('saveList')
      sessionStorage.removeItem('unitList')
      sessionStorage.removeItem('currencyList')
      sessionStorage.removeItem('codeList')
      this.getDetails()
      this.getSelectInfo()
    },
    handleSave() {
      this.tableData.forEach(item => {
        item.bussId = this.formShow.id
        item.feeType = '应收'
      })
      this.tableDataB.forEach(item => {
        item.bussId = this.formShow.id
        item.feeType = '应付'
      })
      const arr = this.tableData.concat(this.tableDataB);
      arr.forEach(item => {
        this.oldList.forEach(ite => {
          if (ite.id == item.id) {
            if (this.diffObj(item, ite) !== null) {
              item.markModify = true
            }
          }
        })
      })
      this.loading = true
      axios.post(this.baseLink + 'FeeRecord/save',
        {
          saveList: arr,
          deleteList: this.deleteList,
          bussId: this.formShow.id
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('tokenDJY')
          }
        })
        .then(res => {
          if (res.data.success) {
            this.$message.success('保存成功')
            this.deleteList = []
            const arr = res.data.data
            const arrA = []
            const arrB = []
            this.oldList = JSON.parse(JSON.stringify(res.data.data))
            arr.forEach(item => {
              if (item.feeType == '应收') {
                arrA.push(item)
              }
              if (item.feeType == '应付') {
                arrB.push(item)
              }
              this.tableData = arrA
              this.tableDataB = arrB
              this.tableDataB.forEach((ite, index) => {
                ite.rowKey = index + 1
              })
              this.tableData.forEach((ite, index) => {
                ite.rowKey = index + 1
              })
              this.$forceUpdate()
            })
            setTimeout(() => {
              this.unloadHandler()
            }, 100);
          } else {
            this.$message.error(res.data.message)
          }
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
        });
    },
    diffObj(obj1, obj2) {
      function getTypeByObj(obj) {
        return Object.prototype.toString.call(obj).match(/^\[object ([a-zA-Z]*)\]$/)[1];
      }
      function isEmptyObject(obj) {
        for (const key in obj) {
          return false;
        };
        return true;
      }
      if (!obj1 || isEmptyObject(obj1) || !obj2 || isEmptyObject(obj2)) {
        return null;
      }
      const diffRes = {
        old_val: {},
        new_val: {}
      };
      for (const k in obj2) {
        // 判断数据类型是否一致
        if (getTypeByObj(obj2[k]) === getTypeByObj(obj1[k])) {
          // 比较 “Array”和“Object”类型
          if (getTypeByObj(obj2[k]) === 'Array' || getTypeByObj(obj2[k]) === 'Object') {
            const diffData = this.diffObj(obj1[k], obj2[k]);
            if (!isEmptyObject(diffData)) {
              diffRes.old_val[k] = diffData.old_val;
              diffRes.new_val[k] = diffData.new_val;
            }
          } else if (obj1[k] !== obj2[k]) { // 比较其他类型数据
            diffRes.old_val[k] = obj1[k];
            diffRes.new_val[k] = obj2[k];
          }
        } else {
          if ([undefined, null, ''].includes(obj1[k]) && [undefined, null, ''].includes(obj2[k])) {
            // 这三类数据可视为相等，不做处理
          } else {
            diffRes.old_val[k] = obj1[k];
            diffRes.new_val[k] = obj2[k];
          }
        }
      }
      // 若没有变化，返回null
      if (isEmptyObject(diffRes.old_val) || isEmptyObject(diffRes.new_val)) {
        return null;
      }
      return diffRes;
    },
    getDetails() {
      const list = sessionStorage.getItem('saveList') ? JSON.parse(sessionStorage.getItem('saveList')) : []
      this.loading = true
      if (list.length !== 0) {
        const flag = []
        list.forEach(item => {
          if (item.id == this.formShow.id) {
            const arr = item.tableData.concat(item.tableDataB)
            this.oldList = JSON.parse(JSON.stringify(arr))
            this.tableData = JSON.parse(JSON.stringify(item.tableData))
            this.tableDataB = JSON.parse(JSON.stringify(item.tableDataB))
            this.loading = false
            flag.push(1)
          }
        })
        if (flag.length === 0) {
          axios.get(this.baseLink + 'FeeRecord/Query?BussId=' + this.formShow.id, {
            headers: {
              Authorization: "Bearer " + localStorage.getItem('tokenDJY')
            }
          })
            .then(res => {
              if (res.data.success) {
                const arr = res.data.data
                const arrA = []
                const arrB = []
                this.oldList = JSON.parse(JSON.stringify(res.data.data))
                arr.forEach(item => {
                  if (item.feeType == '应收') {
                    arrA.push(item)
                  }
                  if (item.feeType == '应付') {
                    arrB.push(item)
                  }
                  this.tableData = arrA
                  this.tableDataB = arrB
                  this.tableDataB.forEach((ite, index) => {
                    ite.rowKey = index + 1
                  })
                  this.tableData.forEach((ite, index) => {
                    ite.rowKey = index + 1
                  })
                  this.$forceUpdate()
                })
              } else {
                this.$message.error(res.data.message)
              }
              this.loading = false
            })
            .catch((error) => {
              this.loading = false
            });
        }
      } else {
        axios.get(this.baseLink + 'FeeRecord/Query?BussId=' + this.formShow.id, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('tokenDJY')
          }
        })
          .then(res => {
            if (res.data.success) {
              const arr = res.data.data
              const arrA = []
              const arrB = []
              this.oldList = JSON.parse(JSON.stringify(res.data.data))
              if (arr.length === 0) {
                this.tableData = []
                this.tableDataB = []
                this.$forceUpdate()
              }
              arr.forEach(item => {
                if (item.feeType == '应收') {
                  arrA.push(item)
                }
                if (item.feeType == '应付') {
                  arrB.push(item)
                }
                this.tableData = arrA
                this.tableDataB = arrB
                this.tableDataB.forEach((ite, index) => {
                  ite.rowKey = index + 1
                })
                this.tableData.forEach((ite, index) => {
                  ite.rowKey = index + 1
                })
                this.$forceUpdate()
              })
            } else {
              this.$message.error(res.data.message)
            }
            this.loading = false
          })
          .catch((error) => {
            this.loading = false
          });
      }

    },
    handleCopy() {
      this.checkboxOption.selectedRowKeys.forEach(item => {
        this.tableData.forEach((ite, index) => {
          if (ite.rowKey == item) {
            const data = JSON.parse(JSON.stringify(ite))
            data.rowKey = this.tableData.length + 1
            if (data.id) {
              delete data.id
            }
            this.tableData.push(data)
          }
        })
      })
    },
    handleCopyB() {
      this.checkboxOptionB.selectedRowKeys.forEach(item => {
        this.tableDataB.forEach((ite, index) => {
          if (ite.rowKey == item) {
            const data = JSON.parse(JSON.stringify(ite))
            data.rowKey = this.tableDataB.length + 1
            if (data.id) {
              delete data.id
            }
            this.tableDataB.push(data)
          }
        })
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    getExchange(val, row) {
      axios.get(this.baseLink + 'FeeCurrencyExchange/QueryExchange?currencyCode=' + val, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem('tokenDJY')
        }
      }).then(res => {
        row['exchangeRate'] = res.data.data.drValue
      }).catch(function (error) {
        console.log(error);
      });

    },
    handleAdd() {
      const data = {
        quantity: 1,
        unitPrice: 0.00,
        taxUnitPrice: 0.00,
        saleCorp: "",
        customerName: "",
        customerType: "",
        feeDescription: "",
        feeName: "",
        feeStatus: "",
        auditDate: "",
        isOpen: false,
        auditOperator: "",
        orderInvSettlement: "",
        updatedTime: "",
        updatedUserName: "",
        invoice: "",
        settlement: "",
        currency: "",
        remark: "",
        exchangeRate: 1,
        taxRate: 0.00,
        noTaxAmount: 0.00,
        amount: 0.00,
        isInvoice: false,
        isAdvancedPay: false,
        rowKey: this.tableData.length + 1
      }
      this.tableData.push(data)
      setTimeout(() => {
        this.$refs['tableRef'].setCellSelection({ rowKey: this.tableData.length, colKey: 'feeName' });
        this.$refs["tableRef"].scrollToColKey('feeName');
        this.$refs["tableRef"].scrollToRowKey(this.tableData.length);
      }, 100);

    },
    handleAddB() {
      const data = {
        quantity: 1,
        unitPrice: 0.00,
        taxUnitPrice: 0.00,
        saleCorp: "",
        customerName: "",
        customerType: "",
        feeDescription: "",
        feeName: "",
        feeStatus: "",
        auditDate: "",
        isOpen: false,
        auditOperator: "",
        orderInvSettlement: "",
        updatedTime: "",
        updatedUserName: "",
        invoice: "",
        settlement: "",
        currency: "",
        remark: "",
        exchangeRate: 1,
        taxRate: 0.00,
        noTaxAmount: 0.00,
        amount: 0.00,
        isInvoice: false,
        isAdvancedPay: false,
        rowKey: this.tableDataB.length + 1
      }
      this.tableDataB.push(data)
      setTimeout(() => {
        this.$refs['tableRefB'].setCellSelection({ rowKey: this.tableDataB.length, colKey: 'feeName' });
        this.$refs["tableRefB"].scrollToColKey('feeName');
        this.$refs["tableRefB"].scrollToRowKey(this.tableDataB.length);
      }, 100);
    },
    setCellSelection(rowKey, colKey) {
      this.$refs['tableRef'].setCellSelection({ rowKey, colKey })
    },
    setCellSelectionB(rowKey, colKey) {
      this.$refs['tableRefB'].setCellSelection({ rowKey, colKey })
    },
    isDOM(item) {
      // 首先判断是否支持HTMLELement，如果支持，使用HTMLElement，如果不支持，通过判断DOM的特征，如果拥有这些特征说明就是ODM节点，特征使用的越多越准确
      return typeof HTMLElement === 'function'
        ? item instanceof HTMLElement
        : item && typeof item === 'object' && item.nodeType === 1 && typeof item.nodeName === 'string'
    },
    handleChange(val, row) {
      this.fetching = true
      this.customerList = []
      axios.get(this.baseLink + 'FeeRecord/GetFeeCustomerList?code=' + val, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem('tokenDJY')
        }
      }).then(res => {
        this.customerList = res.data.data
        if (val === 'consignor') {
          row['customerCode'] = this.formShow.customerid
          row['customerName'] = this.formShow.customername
        }
        if (val === 'fleet') {
          row['customerCode'] = this.formShow.truckerid
          row['customerName'] = this.formShow.trucker
        }
        if (val === 'customs_broker') {
          row['customerCode'] = this.formShow.customserid
          row['customerName'] = this.formShow.customser
        }
        if (val === 'booking_agent') {
          row['customerCode'] = this.formShow.forwarderid
          row['customerName'] = this.formShow.forwarder
        }
        if (val === 'out_agent') {
          row['customerCode'] = this.formShow.agentnameid
          row['customerName'] = this.formShow.agentname
        }
        if (val === 'shipagency') {
          row['customerCode'] = this.formShow.shipagencyid
          row['customerName'] = this.formShow.shipagency
        }
        if (val === 'yard') {
          row['customerCode'] = this.formShow.yardyid
          row['customerName'] = this.formShow.yard
        }
        this.fetching = false
      }).catch(function (error) {
        this.fetching = false
      });
    },
    getSelectInfo() {
      const codeList = sessionStorage.getItem('codeList') ? JSON.parse(sessionStorage.getItem('codeList')) : []
      const currencyList = sessionStorage.getItem('currencyList') ? JSON.parse(sessionStorage.getItem('currencyList')) : []
      const unitList = sessionStorage.getItem('unitList') ? JSON.parse(sessionStorage.getItem('unitList')) : []
      if (codeList.length === 0) {
        axios.get(this.baseLink + 'FeeCode/List', {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('tokenDJY')
          }
        }).then(res => {
          this.codeList = res.data.data
          sessionStorage.setItem('codeList', JSON.stringify(res.data.data))
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.codeList = codeList
      }

      if (codeList.length === 0) {
        axios.get(this.baseLink + 'FeeCurrency/List', {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('tokenDJY')
          }
        }).then(res => {
          this.currencyList = res.data.data
          sessionStorage.setItem('currencyList', JSON.stringify(res.data.data))
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.currencyList = currencyList
      }

      if (unitList.length === 0) {
        axios.get(this.baseLink + 'FeeRecord/GetFeeUnitList', {
          headers: {
            Authorization: "Bearer " + localStorage.getItem('tokenDJY')
          }
        }).then(res => {
          res.data.data.forEach((item, index) => {
            if (!item.name) {
              res.data.data.splice(index, 1)
            }
          })
          this.unitList = res.data.data
          sessionStorage.setItem('unitList', JSON.stringify(res.data.data))
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        this.unitList = unitList
      }
    },
    handleDownA() {
      this.addDownIndex = this.$refs['tableRef'].getRangeCellSelection().selectionRangeKeys.startRowKey
      this.addDownIndexB = null
    },
    handleDownB() {
      this.addDownIndexB = this.$refs['tableRefB'].getRangeCellSelection().selectionRangeKeys.startRowKey
      this.addDownIndex = null
    },
    handleMoveA() {
      this.seleectIndex = this.$refs['tableRef'].getRangeCellSelection().selectionRangeKeys.startRowKey
      this.startColKey = this.$refs['tableRef'].getRangeCellSelection().selectionRangeKeys.startColKey
      this.seleectIndexB = null
      this.startColKeyB = null
    },
    handleMoveB() {
      this.seleectIndexB = this.$refs['tableRefB'].getRangeCellSelection().selectionRangeKeys.startRowKey
      this.startColKeyB = this.$refs['tableRefB'].getRangeCellSelection().selectionRangeKeys.startColKey
      this.seleectIndex = null
      this.startColKey = null
    },

  },
}
</script>

<style lang="less" scoped>
.btn {
  background: rgb(#13c2c2);
  cursor: pointer;
  color: white;
  height: 25px;
  line-height: 25px;
  font-size: 13px;
  text-align: center;
  margin-right: 10px;
  border-radius: 5px;
  padding: 0 10px;
}

.btn.red {
  background: red;
}

.btn.blue {
  background: rgb(22, 155, 213);
}

.title {
  font-size: 20px;
  text-align: left;
  font-weight: bold;
  color: rgb(22, 155, 213);
  margin-bottom: 10px;
}

.main {
  padding: 0 8px;
}

/deep/ .ant-form-item {
  margin-bottom: 3px !important;
}

/deep/ .ant-form-item-label {
  line-height: 20px !important;
}

/deep/ .ant-form-item-control {
  line-height: 20px !important;
}

.opera {
  display: flex;
  align-items: center;

  span {
    font-size: 18px;
    color: black;
  }

  margin-top: 10px;
  margin-bottom: 5px;
}
</style>
<style>
.table-body-cell-class1 {
  height: 20px !important;
  padding: 2px !important;
}

.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content tbody.ve-table-body tr.ve-table-body-tr {
  height: 30px !important;
}

.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content thead.ve-table-header tr.ve-table-header-tr {
  height: 30px !important;
}

.ve-table .ve-table-container .ve-table-content-wrapper table.ve-table-content thead.ve-table-header tr.ve-table-header-tr th.ve-table-header-th {
  padding: 2px !important;
}
</style>




// WEBPACK FOOTER //
// src/view/home/index.vue